import { useMemo, useEffect } from 'react'
import PaginatedPage from '../../components/PaginatedPage'
import TableView from '../../components/TableView'
import { Status, useWindowContext } from '@iqueue/ui-kit'
import NoticesPresents from '../../api/notciesPresents'
import './translations'

import Measurement from '../../components/gasAndOil/Measurement'
import useTranslate, { t } from '../../hooks/useTranslate'
import BasicDateRenderer from '../../utils/renderers'
import { DevEUIFormatter } from '../sensor/SensorsPage'

function NoticeTable(props) {
  const locale = useTranslate()

  const schema = useMemo(() => [{
    key: 'devEUI',
    title: t('notice.table.devEUI'),
    render: (_, item) => <DevEUIFormatter devEUI={ item?.sensor.devEUI }/>,
  }, {
    key: 'sensor.type',
    title: t('notice.table.sensorType'),
    render: (v) => {
      return v ? t(`type.sensor.${ v }`) : 'N/A'
    },
    width: '20rem',
  }, {
    key: 'context.body',
    title: t('notice.table.message'),
    render: (body) => {
      return body ? t(`status.sensor.${ body }`) : 'N/A'
    },
    width: '30rem',
  }, {
    key: 'state',
    title: t('notice.table.value'),
    render: (_, val) => {
      return <Measurement unit={ val?.sensor?.type }>{ val.sensor.state.value[0] }</Measurement>
    },
    width: '14rem',
  }, {
    key: 'type',
    title: t('notice.table.type'),
    render: (name) => {
      return <Status
        warning
        error={ name === 'CRITICAL' }
      >{ t(`notice.type.${ name }`) }</Status>
    },
    width: '30rem',
  }, {
    key: 'createdAt',
    title: t('notice.table.createdAt'),
    render: BasicDateRenderer,
    width: '20rem',
  }, {
    key: 'updatedAt',
    title: t('notice.table.updatedAt'),
    render: BasicDateRenderer,
    width: '20rem',
  }], [t, locale])

  return <TableView
    permissions={ ['READ'] }
    schema={ schema }
    entity={ 'notifications' }
    minWidth={ '155rem' }
    { ...props }
  />
}

export default function NoticePage() {
  const { setTitle, togglePaddings, toggleScrollbars } = useWindowContext()
  const locale = useTranslate()
  const translatedTitle = useMemo(() => t('menu.notices'), [locale])

  useEffect(() => {
    setTitle(translatedTitle)
    togglePaddings(false)
    toggleScrollbars(true)
  }, [translatedTitle])

  return <PaginatedPage
    presenter={ NoticesPresents }
    component={ NoticeTable }
  />
}
